import PromotionsList from './PromotionsList';
export default PromotionsList;
